import * as React from "react";

import { ErrorPageBody } from "spry-react/Errors/errorPageBody";
import { IPortalAppContext } from "../../Shared/appContext";
import { IconKey } from "spry-react/Icon/iconInfo";
import { colors } from "spry-react/utils/colors";
import { PortalFullPage } from "../../Shared/portalPage";

interface Props {
  context: IPortalAppContext;
  title: string;
  headerContent: React.ReactNode;
  errorMessage: React.ReactNode;
  iconKey?: IconKey;
  color?: string;
}
export function PortalBaseErrorPage(props: Props) {
  return (
    <PortalFullPage
      title={props.title}
      context={props.context}
      borderedHeader={true}
      headerContent={props.headerContent}
      children={
        <ErrorPageBody
          errorMessage={props.errorMessage}
          icon={{
            iconKey: props.iconKey ?? "cancel",
            color: props.color ?? colors["error"],
          }}
        />
      }
    />
  );
}
